import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { GetAgentOfflineInstallationsResData } from "./GetAgentOfflineInstallationsResData";

const ENDPOINT = "/agent/offline";

export class GetAgentOfflineInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetAgentOfflineInstallationsReqData;

    constructor(payload: GetAgentOfflineInstallationsReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetAgentOfflineInstallationsResData> {
        let res = await this.executeCommand(this.payload);
        return new GetAgentOfflineInstallationsResData(res);
    }
}

export class GetAgentOfflineInstallationsReqData implements IPaginationFilter, IFilterInstallations {
    installationNames: string[];
    folderIds: number[];
    branchNames: string[];
    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    installationPrefix: string = null;
}
